import { Col, Row } from 'antd';
import classnames from 'classnames';
import React from 'react';

import { useMediaType } from 'technical/media/hooks';

import styles from './sectionTitle.module.scss';

interface Props extends React.HTMLProps<HTMLHeadingElement> {
  label?: string;
  leftButton?: React.ReactNode;
}

function SectionTitle({
  label,
  className,
  leftButton,
  ...rest
}: Readonly<Props>) {
  const { isMobile } = useMediaType();
  return (
    <Row className={classnames(className, styles.sectionTitleContainer)}>
      <Col span={isMobile ? 24 : 4}>
        {leftButton && <span className={styles.leftButton}>{leftButton}</span>}
      </Col>
      {label && (
        <Col span={isMobile ? 24 : 16}>
          <h1 {...rest} className={styles.sectionTitle}>
            {label}
          </h1>
          <div className={styles.lineCenter} />
        </Col>
      )}
    </Row>
  );
}

export default SectionTitle;
